
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.533 10.46l-.007-.002L3.73 3.076a.982.982 0 00-.926.09 1.027 1.027 0 00-.464.858v4.721a1 1 0 00.813.982l9.707 1.795a.167.167 0 010 .327l-9.706 1.795a1 1 0 00-.814.982v4.721a.982.982 0 00.441.82.997.997 0 00.948.087l17.796-7.34.008-.003a1.334 1.334 0 000-2.45z","fill":"currentColor"}})])
          )
        }
      }
    